import { Auth } from "aws-amplify";
import { clearHostedUiToken } from "./hostedUiToken";

let latched = false;

export async function expireSession() {
  if (latched) {
    return;
  }
  latched = true;
  localStorage.removeItem("token");
  clearHostedUiToken();
  try {
    await Auth.signOut();
  } catch {
  }
  window.location.assign("/?session=expired");
}
